import React from 'react';
import { Mail, Phone, Globe, MapPin } from 'lucide-react';
export function EmailSignatureSasa() {
  return <div className="max-w-3xl mx-auto p-8" data-id="element-245">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-246">
        <table cellPadding="0" cellSpacing="0" border={0} style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: '15px',
        lineHeight: '1.4',
        borderCollapse: 'collapse'
      }} data-id="element-247">
          <tbody data-id="element-248">
            <tr data-id="element-249">
              <td style={{
              paddingRight: '32px',
              verticalAlign: 'middle',
              borderRight: '2px solid #1e293b',
              width: '140px'
            }} data-id="element-250">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wxtonoDTZefwd495z2JgnJ/LOGO_ET_SLOGAN_%281%29.jpg" alt="IPcom Logo" style={{
                width: '140px',
                height: 'auto',
                display: 'block'
              }} data-id="element-251" />
              </td>
              <td style={{
              paddingLeft: '32px',
              verticalAlign: 'middle'
            }} data-id="element-252">
                <table cellPadding="0" cellSpacing="0" border={0} style={{
                borderCollapse: 'collapse'
              }} data-id="element-253">
                  <tbody data-id="element-254">
                    <tr data-id="element-255">
                      <td style={{
                      paddingBottom: '10px'
                    }} data-id="element-256">
                        <div style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#0f172a',
                        marginBottom: '2px',
                        letterSpacing: '-0.01em',
                        lineHeight: '1.2'
                      }} data-id="element-257">
                          Saša JOVANOVIC
                        </div>
                        <div style={{
                        fontSize: '15px',
                        color: '#475569',
                        fontWeight: '500',
                        lineHeight: '1.3'
                      }} data-id="element-258">
                          Chargé d'études, IPcom
                        </div>
                      </td>
                    </tr>
                    <tr data-id="element-259">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-260">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-261">
                          Mobile :{' '}
                        </span>
                        <span style={{
                        color: '#1e293b',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-262">
                          07 64 35 74 19
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-263">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-264">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-265">
                          Tél :{' '}
                        </span>
                        <span style={{
                        color: '#1e293b',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-266">
                          +33 (0) 1 47 90 08 19
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-267">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-268">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-269">
                          Email :{' '}
                        </span>
                        <a href="mailto:s.jovanovic@ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-270">
                          s.jovanovic@ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-271">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-272">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-273">
                          Web :{' '}
                        </span>
                        <a href="https://www.ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-274">
                          ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-275">
                      <td style={{
                      paddingTop: '8px'
                    }} data-id="element-276">
                        <div style={{
                        fontSize: '13px',
                        color: '#64748b',
                        lineHeight: '1.4',
                        fontWeight: '400'
                      }} data-id="element-277">
                          17, Avenue des Louvresses, bât B2
                          <br data-id="element-278" />
                          92230 Gennevilliers, France
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}